 <div>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Alert!</h5>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <div class="modal-body text-center">
        You are about to leave this page without saving your changes. How would you like to proceed?
        </div>
        <div class="modal-footer d-block mx-auto">
          <button type="button" class="btn btn-primary" (click)="continue()" >{{data.btnTitle1}}
          </button>
          <button type="button" class="btn btn-cancel" (click)="Discard()" data-dismiss="modal">{{data.btnTitle2}}</button>
        </div>
      </div>
    </div>